const setTimeRange = (n = 'day', m = 1, toValueOf = true) => {
  const start = dayjs().subtract(m, n).set('hour', 0).set('minute', 0).set('second', 0)
  const end = dayjs().set('hour', 23).set('minute', 59).set('second', 59)

  if (toValueOf) {
    return [start.valueOf(), end.valueOf()]
  } else {
    return [start, end]
  }
}

export default setTimeRange
